import classnames from 'classnames2';
import React from 'react';
import { vizColors } from '@opengov/capital-style';
import { Icon } from '../Icon';
import styles from './Badge.scss';
/**
 * Use `Badge` to highlight key info with a predefined status. Easy peasy!
 */

export var Badge = function Badge(_ref) {
  var text = _ref.text,
      variant = _ref.variant,
      maxLength = _ref.maxLength,
      icon = _ref.icon,
      dataTest = _ref.dataTest;
  var badgeText = text; // using an inline style to apply color tokens that are not exposed in CSS.

  var inlineStyle = {};

  if (variant === 'positive') {
    inlineStyle = {
      backgroundColor: vizColors.jade[700]
    };
  } else if (variant === 'negative') {
    inlineStyle = {
      backgroundColor: vizColors.red[700]
    };
  } else if (variant === 'warning') {
    inlineStyle = {
      backgroundColor: vizColors.orange[200]
    };
  }

  if (badgeText && badgeText.length > maxLength) {
    badgeText = "".concat(text.slice(0, maxLength - 1), "...");
  }

  return React.createElement("span", {
    className: classnames(styles.badge, styles[variant]),
    style: inlineStyle,
    "data-test": dataTest,
    title: text
  }, icon && React.createElement(Icon, {
    icon: icon,
    className: styles.icon
  }), badgeText);
};
Badge.defaultProps = {
  text: '',
  variant: 'neutral'
};